unit f_modificaassenza;

{$mode objfpc}

interface

uses
  Classes, SysUtils, js, web, un_widget, un_tquery, w_table, un_generator,
  f_selezione, DateUtils;

type

  { TFrmModificaAssenza }

  TFrmModificaAssenza = class(TWidget)
    nuovorecord :String;
    procedure AfterRender; override;
    procedure AfterDomAppend; async; override;
    idassenza:integer;
    procedure salva_click(Event: TJSEvent); async;
    procedure chiudi_click(Event: TJSEvent); async;
    procedure elimina_click(Event: TJSEvent); async;

  private

  published
    procedure CompilaCampi; async;
    procedure ControlloCompilazioneCampi; async;
    QryModificaAssenza: TQuery;
    QryElimina: TQuery;
    nomeutente: TJSHTMLInputElement;
    dtassenteda: TJSHTMLInputElement;
    dtassentea: TJSHTMLInputElement;
    dsnote: TJSHTMLInputElement;
  end;

implementation

{$R *.html}

{ TFrmModificaAssenza }

procedure TFrmModificaAssenza.AfterRender;
begin
//
end;

procedure TFrmModificaAssenza.AfterDomAppend;
begin

  Await(CompilaCampi);

end;

procedure TFrmModificaAssenza.chiudi_click(Event: TJSEvent);
begin
  Close;
end;

procedure TFrmModificaAssenza.CompilaCampi;
begin
  QryModificaAssenza.Close;
  QryModificaAssenza.SQL.Text:= ' SELECT idco_comunicaassenza, dsvolontario, dtassenteda, dtassentea, dsnote '
                        + ' from vo_comunicaassenza  '
                        + ' where idco_comunicaassenza = ' + IntToStr(idassenza);
  AWait(QryModificaAssenza.Open);

  nomeutente.value := QryModificaAssenza.FieldByName('dsvolontario').AsString;
  dtassenteda.value := Copy(QryModificaAssenza.FieldByName('dtassenteda').AsString,7,4) +'-'+
    Copy(QryModificaAssenza.FieldByName('dtassenteda').AsString,4,2) +'-'+
    Copy(QryModificaAssenza.FieldByName('dtassenteda').AsString,1,2);
  dtassentea.value := Copy(QryModificaAssenza.FieldByName('dtassentea').AsString,7,4) +'-'+
    Copy(QryModificaAssenza.FieldByName('dtassentea').AsString,4,2) +'-'+
    Copy(QryModificaAssenza.FieldByName('dtassentea').AsString,1,2);
  dsnote.value := QryModificaAssenza.FieldByName('dsnote').AsString;
end;

procedure TFrmModificaAssenza.ControlloCompilazioneCampi;
begin
  // controllo se i campi sono compilati
    if dtassenteda.value = '' then
      begin
        ShowMessage('Devi inserire la data da');
        Exit;
      end;

    if dtassentea.value = '' then
      begin
        ShowMessage('Devi inserire la data a');
        Exit;
      end;
end;

procedure TFrmModificaAssenza.salva_click(Event: TJSEvent);
begin
  ControlloCompilazioneCampi;

  QryModificaAssenza.edit;
  QryModificaAssenza.FieldByName('dtassenteda').AsDateTime :=
    EncodeDate(StrToInt(Copy(dtassenteda.value, 1, 4)),
    StrToInt(Copy(dtassenteda.value, 6, 2)),
    StrToInt(Copy(dtassenteda.value, 9, 2)));
  QryModificaAssenza.FieldByName('dtassentea').AsDateTime :=
    EncodeDate(StrToInt(Copy(dtassentea.value, 1, 4)),
    StrToInt(Copy(dtassentea.value, 6, 2)),
    StrToInt(Copy(dtassentea.value, 9, 2)));
  QryModificaAssenza.FieldByName('dsnote').AsString := dsnote.value;
  QryModificaAssenza.Post;
  QryModificaAssenza.ApplyUpdates;

  ShowMessage('Modifica eseguita con successo');

  Close();
end;

procedure TFrmModificaAssenza.elimina_click(Event: TJSEvent); async;
begin

  CompilaCampi;

  if not Window.Confirm('Vuoi procedere con l''eliminazione del record?') then
    Exit;

  QryElimina.Close;
  QryElimina.SQL.Text := 'delete from vo_comunicaassenza ' +
                         'where idco_comunicaassenza = ' +
                         IntToStr(idassenza);

  AWait(QryElimina.ExecuteSql);

  ShowMessage('Eliminazione eseguita con successo');

  Close();

end;

initialization
  RegisterWeb(TFrmModificaAssenza);

end.

